var popup = {
  callById: function(id){
    $('.popup#'+id+'').addClass('on');
    disableScrolling();
  },
  closeById: function(id){
    $('.popup#'+id+'').removeClass('on');
  },
  closeThisPopup: function(el){
    var item = el;

    item.parents('.popup').removeClass('on');
  },
  closePopup: function(){
    $('.popup').removeClass('on');
    enableScrolling();
  },
  callPopup: function(el){
    var item = el;
    var dataPopup = item.getAttribute('data-popup');

    $('.popup[id=\''+dataPopup+'\']').addClass('on');

    disableScrolling();

  },
  collectInformation: function(){
    $('.popup[id=\'collectInformation\']').addClass('on');
    disableScrolling();
  },
  getToken: function(){
    $('.popup[id=\'getTokenInfo\']').addClass('on');
    disableScrolling();
  }
};

var resetGetTokenInfo = function(){
  $('#getTokenInfo select.styled').val("by-email");
  $("#getTokenInfo input[type='text']").val('');
  $('#getTokenInfo .token-method > div').css('display', 'none');
  $('#getTokenInfo .token-method #by-email').css('display', 'block');
  $('#getTokenInfo #by-qr .loading-qr').css('display', 'none');
}

$(document).ready(function(){
  $('body').on('click', '.popup .overlay', function(){
    popup.closePopup();
  });
  $('body').keyup(function (e) {
    if (e.which == 27) {
      popup.closePopup();
    }
  });
  $('body').on('click', '.select-folder li > a', function(){
    // popup.closePopup();
    popup.callById("detailInformation");

  });
});
